import { Text } from '@yes.technology/react-toolkit'
import {
  BalanceCurrent,
  BalanceEdge,
  Container,
  Content,
  Movement,
  MovementArrow,
  NavigationContainer,
  TitleContainer,
  TotalMovement
} from './FlowBalanceChart.styles'
import NavigationSliderSecondary from 'component/NavigationSliderSecondary/NavigationSliderSecondary'
import { FlowBalanceChartProps } from './FlowBalanceChart.types'
import {
  useChartNavigation,
  useProcessedTransactions
} from './FlowBalanceChart.utils'
import { Fragment } from 'react/jsx-runtime'
import { Title } from 'site/Renderer/components/Cockpit/Cockpit.styles'

const FlowBalanceChart = ({ data, text, title }: FlowBalanceChartProps) => {
  const {
    options,
    currentIndex,
    onPrevClick,
    onNextClick,
    disabled,
    disabledArrow
  } = useChartNavigation(data)

  const {
    initialBalance,
    movements,
    lowestMovement,
    highestMovement,
    totalMovementIn,
    totalMovementOut,
    finalBalance
  } = useProcessedTransactions(
    data[currentIndex]?.[1] ?? {
      movements: [],
      initial_balance: { label: '', value: 0 },
      final_balance: { label: '', value: 0 }
    }
  )

  return (
    <Container>
      <TitleContainer>
        <Title>{title}</Title>
      </TitleContainer>
      <NavigationContainer>
        <NavigationSliderSecondary
          textVariant='content-emphasis-04'
          {...{
            options,
            currentIndex,
            onPrevClick,
            onNextClick,
            disabled,
            disabledArrow
          }}
        />
      </NavigationContainer>
      <Content $firstBackground='#e2e8ee' $secondBackground='#d8e1ea' $isHeader>
        <Text variant='content-emphasis-04' alignment='right'>
          {text.header_movement_in}
        </Text>
        <Text variant='content-emphasis-04' alignment='center'>
          {text.header_balance}
        </Text>
        <Text variant='content-emphasis-04' alignment='left'>
          {text.header_movement_out}
        </Text>
      </Content>
      <Content $firstBackground='#f6f7f9' $secondBackground='#ebf0f4'>
        <Text variant='content-emphasis-05' alignment='right'>
          {initialBalance.label}
        </Text>
        <BalanceEdge>
          <Text variant='content-emphasis-05'>{initialBalance.value}</Text>
        </BalanceEdge>
        <div></div>

        {movements.map((movement, index) => (
          <Fragment key={index}>
            <Movement $type='in'>
              <Text variant='content-emphasis-05' alignment='right'>
                {movement.valueIn}
              </Text>
              <Text variant='content-emphasis-05'>{movement.label}</Text>
              <MovementArrow
                $value={movement.valueIn}
                $min={lowestMovement}
                $max={highestMovement}
                $type='in'
              />
            </Movement>

            <BalanceCurrent>
              <Text variant='content-emphasis-05' alignment='center'>
                {movement.balance}
              </Text>
            </BalanceCurrent>

            <Movement $type='out'>
              <Text variant='content-emphasis-05' alignment='left'>
                {movement.valueOut}
              </Text>
              <MovementArrow
                $value={movement.valueOut}
                $min={lowestMovement}
                $max={highestMovement}
                $type='out'
              />
            </Movement>
          </Fragment>
        ))}

        <Text variant='content-emphasis-05' alignment='right'>
          {finalBalance.label}
        </Text>
        <BalanceEdge>
          <Text variant='content-emphasis-05'>{finalBalance.value}</Text>
        </BalanceEdge>
        <div></div>

        <TotalMovement>
          <Text as='div' variant='content-emphasis-05' alignment='right'>
            {text.total_movement_in}: {totalMovementIn}
          </Text>
        </TotalMovement>
        <div></div>
        <TotalMovement>
          <Text as='div' variant='content-emphasis-05'>
            {text.total_movement_out}: {totalMovementOut}
          </Text>
        </TotalMovement>
      </Content>
    </Container>
  )
}

export default FlowBalanceChart
